import axios from "@/axios/index";

export function fetchCompareVersion(client_version) {
	return axios.get("/compare/version", {
		params: {
			client_version
		}
	});
}